export default __webpack_public_path__ + "static/media/unlucky.3d1875cb.png";